<template>
  <v-dialog v-model="dialog" max-width="450px">
      <v-card :loading="loading">
        <v-card-title>{{title}}</v-card-title>
        <v-card-text v-if="event">
            <v-layout wrap>
                <v-flex xs12>
                    <v-form ref="reservationForm">
                        <customer-autocomplete
                            v-model="clientId"
                            :rules="[rules.required]"
                            :disabled="type==='edit'"
                            endpoint="clients/listXperience"
                        ></customer-autocomplete>
                    </v-form>
                </v-flex>
                <v-flex xs12>
                    <v-list dense>
                        <v-list-item>
                            <v-list-item-content>Date:</v-list-item-content>
                            <v-list-item-content class="align-end font-weight-bold">
                                {{date(event.start)}}
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-content>Start:</v-list-item-content>
                            <v-list-item-content class="align-end font-weight-bold">
                                {{hour(event.start)}}
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-content>End:</v-list-item-content>
                            <v-list-item-content class="align-end font-weight-bold">
                                {{hour(event.end)}}
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-content>Bays:</v-list-item-content>
                            <v-list-item-content class="align-end font-weight-bold">
                                {{event.bays}}
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-flex>
            </v-layout>
        </v-card-text>
        <v-card-actions>
            <v-btn @click="dialog=false" :disabled="loading">Cancel</v-btn>
            <v-spacer />
            <v-btn color="secondary" @click="cancel"  v-if="event && event.reserved" :disabled="loading">Cancel reservation</v-btn>
            <v-btn color="accent" @click="submit" v-else :disabled="loading">Submit</v-btn>
        </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment'
import CustomerAutocomplete from "@components/forms/autocomplete/Customer.vue";
import { mapActions } from 'vuex';
export default {
    components:{
        CustomerAutocomplete
    },
    props:{
        event:{
            type:Object,
            default: () => {}
        },
        type:{
            type:String,
            default: () => "create"
        },
        value:{
            type:Boolean,
            required:true
        }
    },
    data: () => ({
        clientId:null,
        loading: false
    }),
    computed:{
        title(){
            return this.event && this.event.reserved?'Update a reservation':"Create a reservation"
        },
        rules: function() {
            return {
                required: value => !!value || "This field is mandatory.",
            };
        },
        dialog:{
            get(){
                return this.value
            },
            set(value){
                this.$emit("input",value)
            }
        }
    },
    methods:{
        ...mapActions("schedulerReservation",{createReservation:'create', cancelReservation:'delete'}),
        ...mapActions("pos",["convertOrder"]),
        hour(date){
            return moment(date).format("HH:mm")
        },
        date(date){
            return moment(date).format("DD-MM-YYYY")
        },
        parseEvent(){
            if(this.event){
                this.event.date = moment(this.event.date);
                this.clientId = this.event.client_id;
            }
        },
        submit(){
            if (this.$refs.reservationForm.validate()) {
                this.loading = true
                this.createReservation({
                    client_id:this.clientId,
                    date: moment(this.event.start).format('YYYY/MM/DD'),
                    start_hour: this.hour(this.event.start),
                    end_hour: this.hour(this.event.end),
                    bays: this.event.bays
                }).then(({order}) => {
                    console.log(order);
                    this.$emit("updateAgenda"),
                    this.dialog=false
                }).finally(() => {
                    this.loading = false
                })
            }
        },
        cancel(){
            this.cancelReservation(this.event.id).then(() => {
                    this.$emit("updateAgenda"),
                this.dialog=false
            })

        }
    }
}
</script>

<style>

</style>